import { ProductInterface } from '../../../../services/exports/Interfaces';
import { IProductOffer } from '../../types';
import { useTranslation } from 'react-i18next';

const useBogoHalfPrice: IProductOffer = () => {
  const { t } = useTranslation(null, { keyPrefix: 'Features:Offers:OfferBadge' });

  return (offer) => {
    const isEligible = (item: ProductInterface) => item && offer.details.products.includes(item.id);
    const badge = offer && t(offer.kind);

    return { isEligible, badge };
  };
};

export default useBogoHalfPrice;
